import { FC, useEffect, useState } from "react";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { icons } from "../../icons/IconSet";
import { getTiketsPrioritiesFilter, ITicketsFilterOption } from "../../store/ticketsFilterSlice";
import DropMenu from "../common/dropmenu/DropMenu";
import Button from "../form/Button";
import Checkbox from "../form/Checkbox";
import TextButton from "../common/buttom/TextButton";

const TicketPriorityFilter : FC<{
  onResetTicketPriority?: () => unknown,
  onClearTicketPriority?: () => unknown,
  onTogglePriority?: (id: ITicketsFilterOption['id']) => unknown,
}> = ({
  onResetTicketPriority,
  onClearTicketPriority,
  onTogglePriority,
}) => {
  const ticketPriorityState = useTypedSelector(getTiketsPrioritiesFilter());

  // --
  // -- Total Selected
  // --
  const [selectedAmount, setSelectedAmount] = useState<number>();
  
  useEffect(() => {
    setSelectedAmount(() => (ticketPriorityState || [])
      .reduce((acc, { isActive }) => acc + (isActive ? 1 : 0), 0))
  }, [ticketPriorityState]);

  return !ticketPriorityState || !ticketPriorityState?.length 
    ? null
    : (
      <DropMenu
        width="238px"
        links={[
          ...ticketPriorityState.map(({ id, name, isActive }) => ({
            name: (
              <div
                key={`col-${name}`}
                tabIndex={-1}
                role="button"
                onClick={() => onTogglePriority && onTogglePriority(Number(id))}
                className="flex justify-between items-center"
              >
                {name}
                <Checkbox
                  name={`col-${name}`}
                  value={isActive}
                  enablePropagation
                />
              </div>
            ),
          })),
          {
            name: (
              <div className="flex justify-end gap-4">
                <TextButton
                  type="gray"
                  onClick={onClearTicketPriority}
                  disabled={ticketPriorityState?.findIndex(({ isActive }) => isActive) === -1}
                  underline
                >
                  Clear
                </TextButton>

                <TextButton
                  type="gray"
                  onClick={onResetTicketPriority}
                  disabled={ticketPriorityState?.length === selectedAmount}
                  underline
                >
                  Reset
                </TextButton>
              </div>
            )
          }
        ]}
      >
        <Button
          isNotFullWidth
          type={ticketPriorityState?.length !== selectedAmount ? 'submit' : 'button'}         
          className="whitespace-nowrap flex gap-1 items-center font-normal pl-3 pr-3 pt-1 pb-1"
        >
          Ticket Priority
          {ticketPriorityState?.length !== selectedAmount && (
            <div>
              {selectedAmount}
              <span className="text-[80%]"> / </span>
              {ticketPriorityState.length}
            </div>              
          )}

          {icons('chevron-down', { width: '14px' })}
        </Button>
      </DropMenu>
    );
}

export default TicketPriorityFilter;
